import React from 'react';
import { Box, Fab, alpha } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { AttachedFileProps } from './types';
import FilePreview from './FilePreview';

const AttachedFile = ({ disabled, file, onDelete }: AttachedFileProps) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <FilePreview file={file} sx={{ width: 80, height: 80, borderRadius: 8, overflow: 'hidden' }} />

      {!disabled && (
        <Fab
          onClick={onDelete}
          style={{
            position: 'absolute',
            width: 24,
            height: 24,
            minHeight: 24,
            top: 3,
            right: 3,
            backgroundColor: alpha('#131313', 0.72),
          }}
        >
          <Close style={{ fontSize: 12, color: 'white' }} />
        </Fab>
      )}
    </Box>
  );
};

export default AttachedFile;
